export default "__VITE_ASSET__DFfHUlI7__"